import { render, staticRenderFns } from "./ArticlesHome.vue?vue&type=template&id=38b44f20"
import script from "./ArticlesHome.vue?vue&type=script&lang=js"
export * from "./ArticlesHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports